<template>
  <div class="customer-holder">
    <div class="columns is-multiline">
      <div class="column is-3">
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="mdi mdi-magnify"></i>
            </span>
            <input class="input" type="text" placeholder="Buscar cliente" v-model.trim="searchText">
          </div>
        </div>
      </div>
      <div class="column is-3">
        <b-field>
          <label class="label" style="margin-right: 10px;">Status</label>
          <b-radio v-model="selectedStatus" native-value="ALL">Todos</b-radio>
          <b-radio v-model="selectedStatus" native-value="TRUE">Ativo</b-radio>
          <b-radio v-model="selectedStatus" native-value="FALSE">Inativo</b-radio>
        </b-field>
      </div>
      <div class="column is-6">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openCreateEditModal()">
            Novo cliente
          </button>
        </div>
      </div>
      <div class="column is-12" v-if="customers.length > 0">
        <div class="table-holder">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th @click="orderBy('name')">
                  <span>Nome</span>
                  <i
                      class="mdi mdi-sort-ascending"
                      v-if="selectedFilter === 'name' && order === 'asc'"
                  ></i>
                  <i
                      class="mdi mdi-sort-descending"
                      v-else-if="selectedFilter === 'name' && order === 'desc'"
                  ></i>
                  <i class="mdi mdi-minus" v-else></i>
                </th>
                <th>E-mail</th>
                <th>Telefone</th>
                <th>CPF</th>
                <th>Ativo?</th>
                <th>Endereço</th>
                <th @click="orderBy('payday')">
                  <span>
                    Dia de cobrança
                  </span>
                  <i
                      class="mdi mdi-sort-ascending"
                      v-if="selectedFilter === 'payday' && order === 'asc'"
                  ></i>
                  <i
                      class="mdi mdi-sort-descending"
                      v-else-if="selectedFilter === 'payday' && order === 'desc'"
                  ></i>
                  <i class="mdi mdi-minus" v-else></i>
                </th>
                <th>Pets</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="customer in customers" :key="customer.id">
                <td>{{ customer.name }}</td>
                <td>{{ customer.email }}</td>
                <td>{{ customer.phone }}</td>
                <td>{{ customer.cpf }}</td>
                <td>{{ customer.active ? 'Sim' : 'Não' }}</td>
                <td>{{ customer.address.street }}, {{ customer.address.number }}, {{ customer.address.cep }}</td>
                <td>{{ customer.payday }}</td>
                <td>
                  <div v-for="pet in customer.pets" :key="pet.id">
                    <span>{{ pet.name }}</span>
                  </div>
                </td>
                <td class="options-holder">
                  <a class="option" @click="openCreateEditModal(customer)"
                    >Editar</a
                  >
                  <a class="option" @click="remove(customer)">Excluir</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">Nenhum cliente foi encontrado.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditCustomerModal from "../components/customer/CreateEditCustomerModal";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import utils from "../helpers/debounce";

export default {
  name: "Customers",
  data: () => ({
    currentPage: 1,
    searchText: "",
    selectedFilter: "name",
    order: "asc",
    selectedStatus: "ALL"
  }),
  computed: {
    ...mapState({
      customers: state => state.customer.customers,
      isLoadingData: state => state.customer.loading,
      totalPages: state => state.customer.totalPages
    })
  },
  watch: {
    searchText: function() {
      this.getCustomerByText();
    },
    selectedStatus: function () {
      this.currentPage = 1;
      this.getData(this.currentPage);
    }
  },
  methods: {
    orderBy(param){
      if(param !== this.selectedFilter){
        this.order = 'asc';
        this.selectedFilter = param;
      }else{
        this.order = this.order === 'desc' ? 'asc' : 'desc';
      }
      this.getData(0);
    },
    ...mapActions({
      getCustomers: "customer/getCustomers",
      removeCustomer: "customer/removeCustomer"
    }),
    ...mapMutations({
      resetFilters: "customer/resetFilters",
      setCustomerFilters: "customer/setQueryFilters",
      setPage: "customer/setPage"
    }),
    openCreateEditModal(customer) {
      this.$modal.show(
        CreateEditCustomerModal,
        { customerParam: Object.assign({}, customer) },
        { width: "850px", height: "auto", adaptive: true, scrollable: true, clickToClose: false},
        {
          closed: () => {
            this.getCustomers();
          }
        }
      );
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.resetFilters();
      let sort = this.selectedFilter + ',' + this.order;
      const isActiveFilter = this.selectedStatus;
      this.setCustomerFilters({ isActiveFilter ,name: this.searchText, sort: sort, page });
      this.getCustomers();
    },
    remove(customer) {
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir o usuário ${customer.name}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removeCustomer(customer.id)
                .then(() => {
                  NotificationsWrapper.success(
                    "Categoria excluída com sucesso!"
                  );
                  this.$modal.hide("dialog");
                  this.getCustomers();
                })
                .catch(() => {
                  NotificationsWrapper.error(
                    "Não foi possível remover a categoria!"
                  );
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    }
  },
  mounted() {
    this.getCustomerByText = utils.debounce(() => {
      this.resetFilters();
      let sort = this.selectedFilter + ',' + this.order;
      this.setCustomerFilters({ name: this.searchText, sort: sort });
      this.getCustomers();
    }, 300);
  },
  created() {
    this.resetFilters();
    let sort = this.selectedFilter + ',' + this.order;
    this.setCustomerFilters({ name: this.searchText, sort: sort });
    this.getCustomers();
    this.$store.commit("setSelectedViewTitle", "Clientes");
  }
};
</script>

<style lang="scss" scoped></style>
